// src/services/data/telephonyProfile.js
// Firestore helpers for telephony profiles with Sentry instrumentation.

import { doc, getDoc, getFirestore, setDoc, updateDoc } from 'firebase/firestore';
import * as Sentry from '@sentry/browser';
import { telephonyProfileDocPath } from '../paths/telephonyPaths';

export const getTelephonyProfile = async (businessId) => {
  const db = getFirestore();
  const path = telephonyProfileDocPath(businessId);
  const ref = doc(db, path);
  const snap = await getDoc(ref);

  if (!snap.exists()) {
    return null;
  }

  return snap.data();
};

export const setTelephonyProfile = async (businessId, data = {}) => {
  const db = getFirestore();
  const path = telephonyProfileDocPath(businessId);
  const ref = doc(db, path);

  try {
    await setDoc(ref, { ...data, _updatedAt: Date.now() }, { merge: true });
  } catch (error) {
    Sentry.withScope((scope) => {
      scope.setLevel('error');
      scope.setTag('telephony.write', 'setDoc');
      scope.setContext('telephonyProfile', { businessId, path });
      Sentry.captureException(error);
    });
    throw error;
  }
};

export const updateTelephonyProfile = async (businessId, data = {}) => {
  const db = getFirestore();
  const path = telephonyProfileDocPath(businessId);
  const ref = doc(db, path);

  try {
    await updateDoc(ref, { ...data, _updatedAt: Date.now() });
  } catch (error) {
    Sentry.withScope((scope) => {
      scope.setLevel('error');
      scope.setTag('telephony.write', 'updateDoc');
      scope.setContext('telephonyProfile', { businessId, path });
      Sentry.captureException(error);
    });
    throw error;
  }
};
